<div class="btn-group" container="body" ngbDropdown role="group" aria-label="Button group with nested dropdown">
  <button class="btn btn-link float-right dropdown-no-arrow" ngbDropdownToggle title="Toggle Actions Dropdown">
    <span class="fa-solid fa-ellipsis-vertical"></span>
  </button>
  <div class="dropdown-menu" ngbDropdownMenu>
    <button ngbDropdownItem
            (click)="onEditMachineGroup(machinegroup)">
      <span class="fa-solid fa-pen"></span>
      <span translate>Edit</span>
    </button>
    <button ngbDropdownItem (click)="onRedirectToConfiguration(machinegroup)">
      <span class="fa-solid fa-gear"></span>
      <span translate>Configuration</span>
    </button>
    <button ngbDropdownItem #deleteButton
            [disabled]="(!isAdminOrHigher && !isDistributorRole) || machinegroup.id === rootMachinegroupId"
            [ngClass]="{'text-danger': !deleteButton.classList.contains('disabled')}"
            (click)="onDeleteMachineGroup(machinegroup)">
      <span class="fa-solid fa-trash"></span>
      <span translate>Delete</span>
    </button>
  </div>
</div>
